// extracted by mini-css-extract-plugin
module.exports = {"metricCard":"Dashboard-module__metricCard___3NqPV","table":"Dashboard-module__table___1SOqL","nameHeader":"Dashboard-module__nameHeader___236cQ"};